<mat-radio-group [(ngModel)]="value">
  <button
    [value]="'先生'"
    (click)="change('先生')"
    [class.selected]="value === '先生'"
  >
    先生
  </button>
  <button
    [value]="'女士'"
    (click)="change('女士')"
    [class.selected]="value === '女士'"
  >
    女士
  </button>
</mat-radio-group>
